import axios from 'axios';

type ApiErrorResponse = {
  error?: string;
  details?: { message?: string };
};

const errorKeysAndStrings = {
  forbidden: 'You are not authorized to perform this action.',
  api_key_with_name_already_exists: 'An API key with same name is already in use.',
};

type ErrorKey = keyof typeof errorKeysAndStrings;

function isErrorKey(key: string): key is ErrorKey {
  return Object.hasOwn(errorKeysAndStrings, key);
}

export const getErrorMessageFromAPIError = (error: unknown): string | undefined => {
  if (!axios.isAxiosError<ApiErrorResponse>(error) || !error.response) return undefined;
  const errorData = error.response.data;

  if (!errorData) return undefined;
  // The error message is in different places of the error object, depending on if it is a Joi or Http error in the API.
  // See 'error-handler.js' in the API repo for more details.
  const errorMessage = errorData.details?.message || errorData.error;
  const localizedErrorMessage =
    errorMessage && isErrorKey(errorMessage) ? errorKeysAndStrings[errorMessage] : undefined;

  return localizedErrorMessage || errorMessage;
};

export const getErrorMessageFromBlobAPIError = async (error: unknown): Promise<string | undefined> => {
  if (!axios.isAxiosError(error) || !(error.response?.data instanceof Blob)) return undefined;
  try {
    const errorData: ApiErrorResponse = JSON.parse(await error.response.data.text());
    return errorData.details?.message;
  } catch {
    return undefined;
  }
};
